<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4 text-center">
              <b-spinner variant="primary" />
              <p class="mt-3">{{ $t('confirmEmail.confirming') }}</p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmEmail',
  mounted() {
    window.location.href = this.$http.defaults.baseURL + '/v1/user/confirm/' + this.$route.params.uuid
  }
}
</script>
